export const DEACTIVATE_USERS_MESSAGE = `
  Deactivating the users below will remove their login access. No data will be deleted.
`;

export const DEACTIVATE_VOICE_USER_MESSAGE = `
  Deactivating the users below will remove their login access and delete all voice settings.
  Deleting voice settings cannot be undone.
`;
